import { AxiosInstance } from "axios";

export abstract class BaseApi {
  protected abstract axiosInstance: AxiosInstance;
}
